import React, { useMemo } from 'react';
import { DownloadIcon, MailIcon } from 'lucide-react';
import { termsMeta, termsSections } from '../data/termsOfService';
import { PolicyContents } from '../components/legal/PolicyContents';
import { PolicySectionBody } from '../components/legal/PolicySectionBody';
import { BackToTop } from '../components/legal/BackToTop';
import { SiteFooter } from '../components/ui/SiteFooter';
import { SiteHeader } from '../components/ui/SiteHeader';
import { useActiveSection } from '../hooks/useActiveSection';
const metaLinkStyles = 'inline-flex items-center gap-2 text-sm font-medium text-purple-700 underline underline-offset-4 decoration-purple-300 hover:text-purple-900 hover:decoration-purple-700 transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory rounded';
export function TermsOfServicePage() {
  const sectionIds = useMemo(() => termsSections.map(section => section.id), []);
  const activeId = useActiveSection(sectionIds);
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-974" data-mp="cmqfx8uwy54g">
      {/* Navigation */}
      <SiteHeader currentPath="/terms-of-service" data-id="element-975" data-mp="3v1r9savzbb8m" />

      <main className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-976" data-mp="2wx5wcaf5y2b">
        {/* Title area */}
        <header className="pt-16 md:pt-24 pb-10 md:pb-14 border-b border-charcoal/10" data-id="element-977" data-mp="2uukk5k7ot3x">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-5" data-id="element-978" data-mp="qnayq50tw0xy">
            {termsMeta.company}
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.05] tracking-tight" data-id="element-979" data-mp="hmctxkikfpeb">
            {termsMeta.title}
          </h1>
          <p className="mt-6 max-w-[62ch] text-lg text-charcoal/70 font-light leading-relaxed" data-id="element-980" data-mp="mj3a07udekzq">
            {termsMeta.summary}
          </p>

          <dl className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm" data-id="element-981" data-mp="37avpdyturibe">
            <div className="flex items-baseline gap-2" data-id="element-982" data-mp="1cux8d7fgg4nb">
              <dt className="text-charcoal/50" data-id="element-983" data-mp="1cuf3xnin2k4b">Effective</dt>
              <dd className="font-medium text-charcoal" data-id="element-984" data-mp="17vby40uu49va">{termsMeta.effectiveDate}</dd>
            </div>
          </dl>

          <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-985" data-mp="1342992h41akg">
            <a href={termsMeta.pdfUrl} target="_blank" rel="noopener noreferrer" className={metaLinkStyles} data-id="element-986" data-mp="z41wdm9nt7fi">
              <DownloadIcon aria-hidden="true" className="w-4 h-4" data-id="element-987" data-mp="u4pb35yfs8f1" />
              Download the PDF
            </a>
            <a href={`mailto:${termsMeta.email}`} className={metaLinkStyles} data-id="element-988" data-mp="p4ayrbpsycb7">
              <MailIcon aria-hidden="true" className="w-4 h-4" data-id="element-989" data-mp="k5pzpfmadyoc" />
              {termsMeta.email}
            </a>
          </div>
        </header>

        {/* Index + body */}
        <div className="lg:grid lg:grid-cols-[16rem_minmax(0,1fr)] lg:gap-14 xl:gap-20 pb-24 md:pb-32" data-id="element-990" data-mp="2ekafpeznx61e">
          <PolicyContents sections={termsSections} activeId={activeId} label="Terms of Service sections" data-id="element-991" data-mp="2aip5y2ifd7vf" />

          <article className="max-w-[68ch] pt-10 lg:pt-14" data-id="element-992" data-mp="3sgk3bar09stv">
            <p className="pb-12 text-base text-charcoal/80 leading-[1.8]" data-id="element-993" data-mp="3sg23k454wwh7">{termsMeta.preamble}</p>

            <div className="divide-y divide-charcoal/10 border-t border-charcoal/10" data-id="element-994" data-mp="1867yidt8cs0">
              {termsSections.map(section => <PolicySectionBody key={section.id} section={section} data-id="element-995" data-mp="a22uhyavzr7y" />)}
            </div>

            <p className="pt-12 text-sm text-charcoal/50" data-id="element-996" data-mp="39hzh9x3z1dn3">
              © 2026 Fem Entity Inc. All rights reserved. Effective {termsMeta.effectiveDate}.
            </p>
          </article>
        </div>
      </main>

      <BackToTop data-id="element-997" data-mp="3ihuus8l01kqa" />

      <SiteFooter currentPath="/terms-of-service" data-id="element-998" data-mp="3igkwbia8iaj4" />
    </div>;
}